/* eslint-disable tailwindcss/no-custom-classname */
import { useState } from 'react'
import { initialStyles, Modal } from '@/components/modal/Modal'
import { postThemeSummaryResult } from '@/api/school'
import { SchoolSurveyMessageModal, SchoolSurveyRadios } from './'
const modalStyle = {
  ...initialStyles,
  content: {
    ...initialStyles.content,
    width: '500px',
    borderRadius: '10px',
  },
}

interface Props {
  isOpen: boolean
  themeId: string
  summaryId: number
  title: string
  onClose: () => void
}
export const SchoolSurveyModal: React.FC<Props> = ({
  isOpen,
  themeId,
  summaryId,
  title,
  onClose,
}) => {
  const [completeModalOpen, setCompleteModalOpen] = useState(false)
  const [errorModalOpen, setErrorModalOpen] = useState(false)
  const [survey, setSurvey] = useState({
    answer_score_1: 0,
    answer_score_2: 0,
    answer_score_3: 0,
  })
  const onClickRadio1 = (value: number) => {
    setSurvey({
      ...survey,
      answer_score_1: value,
    })
  }
  const onClickRadio2 = (value: number) => {
    setSurvey({
      ...survey,
      answer_score_2: value,
    })
  }
  const onClickRadio3 = (value: number) => {
    setSurvey({
      ...survey,
      answer_score_3: value,
    })
  }
  const onClick = async (e) => {
    e.stopPropagation()
    onClose()
    // 振り返り結果を送信する
    const res = await postThemeSummaryResult(
      themeId,
      survey.answer_score_1,
      survey.answer_score_2,
      survey.answer_score_3,
      summaryId
    )
    if (res.result) {
      // 振り返り完了モーダルを表示
      setCompleteModalOpen(true)
    } else {
      // エラーモーダルを表示
      setErrorModalOpen(true)
    }
  }
  const onBackTheme = () => {
    setErrorModalOpen(false)
    location.href = `/user/school/theme/${themeId}`
  }
  return (
    <>
      <Modal open={isOpen} onRequestClose={onClose} style={modalStyle}>
        <div className="p-[30px] border-none">
          <button
            type="button"
            className="float-right p-0 text-[21px] font-bold leading-4 text-black hover:text-black hover:no-underline border-none opacity-20 hover:opacity-50 cursor-pointer hover:cursor-pointer shadow-[0_1px_0_#fff]"
            onClick={onClose}
          >
            <span>×</span>
          </button>
          <p className="text-2xl font-normal tracking-normal text-center text-[#333] uppercase opacity-100">
            振り返り
          </p>
          <p className="mb-0 tracking-normal text-center text-[#333] opacity-100">
            「<span className="text-base font-bold leading-6">{title}</span>
            」の内容を振り返りましょう！
          </p>
        </div>
        <div>
          <SchoolSurveyRadios
            title="内容に満足できましたか？"
            name="survey1"
            onClick={onClickRadio1}
          />
          <SchoolSurveyRadios
            title="内容を理解できましたか？"
            name="survey2"
            onClick={onClickRadio2}
          />
          <SchoolSurveyRadios
            title="内容は今後に役立ちそうですか？"
            name="survey3"
            onClick={onClickRadio3}
          />
        </div>
        <div className="text-center">
          <button
            className="mx-0 mt-[10px] mb-10 w-[129px] h-11 tracking-normal text-center text-white uppercase bg-[#316ab0] rounded-[22px] border-none"
            onClick={onClick}
          >
            完了
          </button>
        </div>
      </Modal>
      <SchoolSurveyMessageModal
        isOpen={completeModalOpen}
        title="振り返り完了"
        message={`「${title}」を読んで学びになったことはありましたか？`}
        buttonText="テーマ詳細へ戻る"
        onClose={() => setCompleteModalOpen(true)}
        onClickButton={onBackTheme}
      />
      <SchoolSurveyMessageModal
        isOpen={errorModalOpen}
        title="振り返り登録エラー"
        message="振り返りの登録に失敗しました。お手数ですがもう一度やり直してください"
        buttonText="閉じる"
        onClose={() => setErrorModalOpen(false)}
        onClickButton={() => setErrorModalOpen(false)}
      />
    </>
  )
}
